import McmQuickConfig from '~/tenants/mcm/performable/quick/McmQuickConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default class McmQuickJob extends McmJob<typeof McmQuickConfig> {
  get performable() {
    return McmQuickConfig;
  }

  get deliverable() {
    return DeliverableType.VIDEO;
  }

  get media() {
    return PersonaType.PROVIDER;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmQuickConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];

    lines.push({
      id: 'photo',
      description: 'Quick Hit Video',
      amount: new Big('35'),
    });

    return lines;
  }

  get hidden() {
    return !this.buyer('sothebys');
  }
}
